<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <h5 class="mb-0"><i class="fa fa-fw fa-dashboard mr-2" />Dashboard</h5>
                <hr />
                <div style="height:330px;">
                    
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
        }
    },
    methods: {

        init() {

            this.initStatus = 0
            
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => {
                this.initStatus = -1
            })
        },

        getItems(){
            
            this.isBusy = true

            this.$axios.get("/admin/getRetailPricing").then(res => {
                
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

    },
    created() {

        this.init()
        
    }
}
</script>
